import { zipRecordPermissions } from './recordPermissions'
import type { FgaComputedRelation } from './generated/model'

/**
 * What a caller may do to one workflow: every computed relation the model defines on `workflow`, paired
 * with the camelCase key it is reported under.
 */
export const WORKFLOW_RECORD_PERMISSIONS = [['canCreateRequest', 'can_create_request']] as const satisfies readonly (readonly [
  string,
  FgaComputedRelation<'workflow'>,
])[]

export type WorkflowRecordPermissionKey = (typeof WORKFLOW_RECORD_PERMISSIONS)[number][0]

export type WorkflowRecordPermissions = Record<WorkflowRecordPermissionKey, boolean>

/** The answer for a caller with no access, and the seed every result is built from. */
export const NO_WORKFLOW_RECORD_PERMISSIONS: WorkflowRecordPermissions = {
  canCreateRequest: false,
}

export const toWorkflowRecordPermissions = (allowed: readonly boolean[]): WorkflowRecordPermissions =>
  zipRecordPermissions('workflow', WORKFLOW_RECORD_PERMISSIONS, NO_WORKFLOW_RECORD_PERMISSIONS, allowed)
